var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2387 3.86876C15.7527 2.92834 14.9264 2.18917 13.987 1.70212C13.0664 1.22478 12.0069 0.974789 10.9814 1.1286C9.89242 1.29195 8.88062 1.92179 8.25402 2.827C7.88119 3.36562 7.64706 3.99728 7.56741 4.647C7.10431 4.27366 6.56119 3.99924 5.9833 3.85817C4.91297 3.59783 3.73895 3.79868 2.81602 4.40007C1.94708 4.96648 1.32113 5.85664 0.950068 6.82479C0.571263 7.81293 0.444634 8.91486 0.705869 9.94035C1.03313 11.2253 1.78341 12.4821 2.8254 13.3012C3.92611 14.1667 5.35991 14.658 6.73722 14.9071C9.05322 15.3262 12.0754 15.8047 12.0754 15.8047C12.0754 15.8047 13.577 13.4389 15.0299 11.5873C15.8941 10.486 16.6394 9.16649 16.8873 7.78867C17.1218 6.48438 16.8476 5.04588 16.2387 3.86876Z",
    fill: "#E4DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group-3.7659d6598b1fd6f015b794a15fb14dab.svg";
export { ForwardRef as ReactComponent };